/**
 * Constants
 * */
export const moduleName = `menu`;

/**
 * Reducer
 * */

export default function reducer(state = false, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const menuSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
